import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "./modal/ConfirmDialog";
import ImagePreviewOverlay from "./modal/ImagePreviewOverlay";

function ImageThumbnailGallery({ files, onDelete, canDelete }) {
  const { t } = useTranslation();
  const [previewIndex, setPreviewIndex] = useState(null);
  const [confirmFileId, setConfirmFileId] = useState(null);

  const thumbnailFiles = useMemo(
    () => files.filter((file) => file.is_thumbnailable),
    [files]
  );

  if (thumbnailFiles.length === 0) {
    return null;
  }

  return (
    <>
      {thumbnailFiles.map((file, index) => (
        <div
          key={file.id}
          className="d-inline-block position-relative me-2 mb-2"
        >
          <img
            className="rounded border-end border-bottom"
            style={{ width: "unset", height: "100px", cursor: "pointer" }}
            src={`/v1/files/${file.id}/thumbnails?height=100`}
            alt=""
            onClick={() => setPreviewIndex(index)}
            role="button"
          />
          {onDelete && (!canDelete || canDelete(file)) && (
            <span
              className="position-absolute d-flex align-items-center justify-content-center bg-danger text-white rounded-circle thumbnail-delete-badge"
              style={{
                top: "-6px",
                right: "-6px",
                width: "20px",
                height: "20px",
                cursor: "pointer",
                fontSize: "11px",
                opacity: 0.5,
                transition: "opacity 0.15s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setConfirmFileId(file.id);
              }}
              role="button"
            >
              <i className="fa fa-xmark" />
            </span>
          )}
        </div>
      ))}

      {previewIndex !== null && (
        <ImagePreviewOverlay
          files={thumbnailFiles}
          initialIndex={previewIndex}
          onClose={() => setPreviewIndex(null)}
        />
      )}

      {confirmFileId !== null && (
        <ConfirmDialog
          title={t("common.delete")}
          message={t("files.confirm_delete")}
          confirmLabel={t("common.delete")}
          confirmClassName="btn btn-danger"
          onCancel={() => setConfirmFileId(null)}
          onConfirm={() => {
            const fileId = confirmFileId;
            setConfirmFileId(null);
            onDelete(fileId);
          }}
        />
      )}
    </>
  );
}

ImageThumbnailGallery.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      is_thumbnailable: PropTypes.bool,
      filename: PropTypes.string,
    })
  ).isRequired,
  onDelete: PropTypes.func,
  canDelete: PropTypes.func,
};

export default ImageThumbnailGallery;
